import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HOME_COPY } from '../data/home-microempresario.content';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

/**
 * Recordatorio v2 al re-login con solicitud en borrador al 100 %.
 */
@Component({
  selector: 'app-home-enviar-modal',
  templateUrl: './home-enviar-modal.component.html',
  styleUrls: ['./home-enviar-modal.component.scss'],
  standalone: false,
})
export class HomeEnviarModalComponent {
  @Input() open = false;
  @Input() mensaje = '';
  @Input() enviando = false;

  @Output() closed = new EventEmitter<void>();
  @Output() revisar = new EventEmitter<void>();
  @Output() enviar = new EventEmitter<void>();

  readonly copy = HOME_COPY.modalEnviarRecordatorio;

  constructor(private readonly analyticsTag: AnalyticsTagService) {}

  onClose(): void {
    if (this.enviando) {
      return;
    }
    this.closed.emit();
  }

  onRevisar(): void {
    if (this.enviando) {
      return;
    }
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaRevisar,
      ctaSection: 'home',
      ctaComponent: 'home-enviar-modal',
      ctaElementId: 'btn-home-enviar-revisar',
      hu: '8099',
    });
    this.revisar.emit();
  }

  onEnviar(): void {
    if (this.enviando) {
      return;
    }
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaEnviar,
      ctaSection: 'home',
      ctaComponent: 'home-enviar-modal',
      ctaElementId: 'btn-home-enviar-solicitud',
      hu: '8099',
    });
    this.enviar.emit();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
